// INTELIMOVE-SAAS-007 (IM-ADR-025): catálogo público, contratação, aceite, retomada e onboarding.
import { z } from 'zod';

export interface CommercialReadinessCheck { key: string; label: string; ok: boolean }
export interface CommercialReadinessDto { enabled: boolean; activationRequested: boolean; checks: CommercialReadinessCheck[]; funnel?: {
  registrationsStarted:number; registrationsCompleted:number; verificationsPending:number; contractsStarted:number; paymentsPending:number;
  subscriptionsActivated:number; contractFailures:number; onboardingsIncomplete:number;
} }
export interface PublicOfferDto {
  id: string; planCode: string; name: string; description: string; versionNo: number; seats: number | null; seatsUnlimited: boolean;
  credits: number | null; priceMinor: number; currency: string; billingPeriod: 'MENSAL' | 'ANUAL' | 'ESPECIAL'; trialDays: number | null;
  features: Array<{ key: string; label: string; description: string; mode: string; limit: number | null; period: string | null; credits: number | null }>;
  conditions: Record<string, unknown>;
}
export interface PublicCommercialCatalogDto { offers: PublicOfferDto[]; contractingAvailable: boolean; message: string | null }

export const CommercialSignupRequest = z.object({
  name: z.string().trim().min(2).max(120), email: z.string().trim().toLowerCase().email().max(254),
  password: z.string().min(10).max(512), planVersionId: z.string().uuid(),
}).strict();

export const CommercialOrganizationRequest = z.object({
  companyName: z.string().trim().min(2).max(120), website: z.string().trim().max(2000).optional(),
  cnpj: z.string().trim().regex(/^\d{14}$/).optional(), planVersionId: z.string().uuid(),
  idempotencyKey: z.string().regex(/^[A-Za-z0-9._:-]{8,200}$/),
}).strict();
export const StartCommercialContractRequest = z.object({
  planVersionId: z.string().uuid(), idempotencyKey: z.string().regex(/^[A-Za-z0-9._:-]{8,200}$/),
}).strict();
export const AcceptCommercialContractRequest = z.object({
  documentIds: z.array(z.string().uuid()).length(4),
}).strict();
export const EmailVerificationConfirmRequest = z.object({ token: z.string().min(32).max(128) }).strict();
export const CommercialPublicationRequest = z.object({ enabled: z.boolean(), reason: z.string().trim().min(5).max(500), code: z.string().regex(/^\d{6}$/) }).strict();
export const OnboardingProgressRequest = z.object({
  step: z.enum(['MINHA_EMPRESA','CONHECENDO_NEGOCIO','MEU_OBJETIVO','PREPARACAO','COMECAR','CONCLUIDO']),
  objective: z.enum(['EMPRESAS','CONCORRENTES','MERCADO','PLANEJAMENTO','ACOMPANHAMENTO']).nullable().optional(),
  preparation: z.record(z.string(), z.union([z.string(),z.number(),z.boolean(),z.null()])).optional(),
}).strict();

export interface CommercialProgressDto {
  emailVerified: boolean; mailAvailable: boolean; readiness: CommercialReadinessDto;
  contract: null | { id: string; status: string; planVersionId: string; planName: string; versionNo: number; priceMinor: number; currency: string; billingPeriod: string; seats: number; includedCredits: number | null; createdAt: string; updatedAt: string };
  documents: Array<{ id: string; kind: string; version: string; title: string; url: string; accepted: boolean }>;
  onboarding: null | { step: string; objective: string | null; preparation: Record<string, unknown>; completedAt: string | null; updatedAt: string };
}
